import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { InteractiveCardRoot } from './InteractiveCard.style';

const InteractiveCard = forwardRef(
  ({ selected = false, disabled = false, ...rest }, ref) => {
    return (
      <InteractiveCardRoot
        data-qa-id="interactive-card--root"
        selected={selected}
        disabled={disabled}
        tabIndex={disabled ? undefined : 0}
        ref={ref}
        {...rest}
      />
    );
  }
);

InteractiveCard.propTypes = {
  selected: PropTypes.bool,
  disabled: PropTypes.bool
};

InteractiveCard.displayName = 'InteractiveCard';

export default InteractiveCard;
